module.exports = __webpack_public_path__ + "img/Primordial-Process-1-mobile.5c9efb3b.png";